import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    backgroundColor: '#ffb2b2',
    borderRadius: 3,
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    flexDirection: 'column',
    paddingVertical: 15,
    paddingHorizontal: 20,
    gap: 10,
  },
  image: {
    width: 15,
    height: 15,
    marginRight: 5,
  },
});
